import mongoose from 'mongoose';

const { Schema } = mongoose;

const CountObject = new Schema(
  {
    period: Number,
    count: Number,
  },
  { _id: false },
);

const UserCountSchema = new Schema({
  timeUpdated: { type: Number },
  domain: { type: String },
  counts: [CountObject],
});

const UserCountModel = () => mongoose.model('userCount', UserCountSchema, 'UserCount');

UserCountSchema.statics.newUserCount = async (update) => {
  try {
    const UserCount = UserCountModel();
    await UserCount.update({ domain: update.domain }, update, { upsert: true });
  } catch (err) {
    return err;
  }
  return 'nothing';
};

UserCountSchema.statics.findUserCount = (domain) => {
  const UserCount = UserCountModel();

  return UserCount.find(
    { domain: { $regex: `.*${domain}.*` } },
    (err, data) => {
      if (err) {
        return err;
      }
      return data;
    },
  );
};

// UserCountSchema.statics.updateCounts = ()

export default UserCountModel;
